console.log("f isMobile:" + isMobile);

if (isMobile) {
  initBuyGetFree();
  intiAddCard();
} else {
  initBuyGetFree();
  intiAddCard();
  initPcProductItem();
  initNavFixed();
  initBannerCss();
}

function initBuyGetFree() {
  let buy_html = "<div class='buy_get_free' style='transform:scale(0.9);'>BUY 2 GET 1 FREE</div><div class='buy_get_free' style='transform:scale(0.9);'>BUY MORE GET MORE FREE</div>";
  if(!isMobile){
      buy_html = "<div class='buy_get_free'>BUY 2 GET 1 FREE, BUY MORE GET MORE FREE</div>"
     $(".price__container").after(
    buy_html
  );
  }else{
     $(".price__container").after(
    buy_html
  );
  let html = `<span clas="50_off" style="
    color: #C30917;
    font-family: 'hc-light';
    font-weight: 800;
    font-size: 13px;
">(50% OFF)</span>`;
  $(".price-item--sale .money").after(html);
  }
}

function intiAddCard() {
  if(isMobile){
  html = `<a href="javascript:void(0);" class="add_cart_box_btn" style="
    background: #fff;
    display: block;
    width: 80%;
    text-align: center;
    margin: 0 auto;
    border: 1px solid #1B1C17;
    padding: ${isMobile?3:0}px 15px;
    border-radius: 15px;
    margin-top: ${isMobile?5:0}px;
    margin-bottom: ${isMobile?15:0}px;
color: #1B1C17;
    text-decoration: none;
    display:${isMobile?"block":"none"};
">ADD TO CART</a>`;
  $("div.card__information  div.price.price--on-sale > div:nth-child(3)").after(
    html
  );
  }else{
    console.log("add to cart");
    html = `<a href="javascript:void(0);" class="add_cart_box_btn" style="
    width: 100%;
    padding: 10px 0;
    text-align: center;
    background: #C10118;
    color: #fff;
    display:block;
    margin-top:-20px;
">ADD TO CART</div>`;
    $(".caption-large.light").closest(".card__content").after(html);
  }

  document.querySelectorAll(".add_cart_box_btn").forEach((item) => {
  item.addEventListener("click", function () {
    item
      .closest(".card")
      .querySelector(".hover_button .add-to-cart button")
      .click();
  });

  if(!isMobile){
    $(".add_cart_box_btn").hide();
    $(".product-grid li.grid__item").mousemove(function () {
      console.log("mousemove");
      $(".add_cart_box_btn").hide();
      $(this).find(".add_cart_box_btn").show();
      $(this).find(".buy_get_free").hide();
      $(this).closest("li").find(".price__container").css("margin-bottom","0px");
    });
    $(".product-grid li.grid__item").mouseleave(function () {
      console.log("mouseleave");
      $(this).find(".add_cart_box_btn").hide();
      $(this).find(".buy_get_free").show();
      $(this).closest("li").find(".price__container").css("margin-bottom","10px");
    });
  }  
});

  document.querySelectorAll(".card__heading.h5 a").forEach((item) => {
  if(isMobile){  
  item.innerText = "";
  }
  let href = item.getAttribute("href");
  item
    .closest(".card")
    .querySelector(".card__inner .card__media")
    .addEventListener("click", () => {
      location.href = href;
    });
});
}

$(".collection li.grid__item").each(function (index, el) {
   let html = `<div style="
    position: absolute;
    top: 5px;
    left:5px;
    width:${isMobile?70:100}px;
    height:${isMobile?26:30}px;
    z-index: 999;
"><img src="https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/e4ab833d9e2007cf9e21ff31d64b8b5c_200x.jpg?v=1685031579"/></div>`;
  if(isMobile){
      $(el).css("padding- top", "15px");
  }else{
    html = `<div style="
    position: absolute;
    top: 0px;
    left:0px;
    width:${isMobile?79:90}px;
    height:${isMobile?26:26}px;
    z-index: 999;
"><img src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/e4ab833d9e2007cf9e21ff31d64b8b5c.jpg?v=1685031579"/></div>`;
    $(el).css("position", "relative");
  }
  $(el).css("position", "relative");
  $(el).append(html);
});

[2, 3, 4, 5, 6].forEach((id) => {
  try {
    let more_html = `<div id="div_${id}" class="more_btn" style="position:absolute;"></div>`;
    document
      .querySelector("#\\3" + id)
      .insertAdjacentHTML("beforebegin", more_html);
    let more_btn_html = document
      .querySelector("#div_" + id)
      .closest("section")
      .previousElementSibling.querySelector(".collection__view-all").innerHTML;
    document.querySelector("#div_" + id).innerHTML = more_btn_html;
    document.querySelector("#div_" + id).querySelector("a").innerText =
      "LOAD MORE >";
    document.querySelector("#div_" + id).querySelector("a").style.minHeight =
      "1rem";
    document.querySelector("#div_" + id).querySelector("a").style.padding =
      "1rem 5rem";
    $(`#div_${id} a`).css("font-family", "ui-monospace");
    $(`#div_${id} a`).css("font-weight", "400");
    $(`#div_${id} a`).css("color", "#505050");

    let self_width = document.querySelector("#div_" + id).clientWidth;
    let left =
      (document.querySelector(
        "#MainContent .shopify-section.section:nth-child(n+5)"
      ).clientWidth -
        self_width) /
      2;
    document.querySelector("#div_" + id).style.left = left + "px";
    document.querySelector("#div_" + id).style.top = "2%";
  } catch (e) {
    console.log(e);
  }
});

function initPcProductItem(){
  $(".buy_get_free").css("font-size","15px");  
  $(".price__container span").css("font-size","15px");
}

function initNavFixed(){
  //监听滚动如果当前高度小于banner高度导航定在banner底部
  let id1 = $("#1").offset().top+100;
  let id2 = $("#2").offset().top+100;
  let id3 = $("#3").offset().top+100;
  $(window).scroll(function(event){
		 var toTop = $(window).scrollTop();
         console.log("id1:"+id1+" id2:"+id2+" id3:"+id3);
		 console.log(toTop);

         if(toTop <= 800){
           console.log("bottom...");
           $("#shopify-section-template--18984936636761__27640cb0-80fd-4e12-b895-3d034200a14d").css("position","static");
         }else{
           $("#shopify-section-template--18984936636761__27640cb0-80fd-4e12-b895-3d034200a14d").css("position","fixed");
           $("#shopify-section-template--18984936636761__27640cb0-80fd-4e12-b895-3d034200a14d").css("top","140px");
         }

         if(toTop < id2){
            $("#nav_map li a").removeClass("active");
            $("a[href='#1']").addClass("active");
         }else if(toTop >= id2 && toTop < id3){
           $("#nav_map li a").removeClass("active");
            $("a[href='#2']").addClass("active");
         }else{
           $("#nav_map li a").removeClass("active");
            $("a[href='#3']").addClass("active");
         }
         
  });
  $("#nav_map li").each(function(index,el){
    $(el).find("a").text($(el).find("a").html().replace("<br>"," "));
    $(el).click(function(){
      $("#nav_map li a").removeClass("active");
      $(this).find("a").addClass("active");
    });
  });
}

function initBannerCss(){
  $("#1").closest(".color-background-1.gradient>div").css("margin-top","100px");
  $("#1").closest(".color-background-1.gradient>div").css("border-top-left-radius","25px");
  $("#1").closest(".color-background-1.gradient>div").css("border-top-right-radius","25px");

  $("#2").closest(".color-background-1.gradient>div").css("margin-top","100px");
  $("#2").closest(".color-background-1.gradient>div").css("border-top-left-radius","25px");
  $("#2").closest(".color-background-1.gradient>div").css("border-top-right-radius","25px");

  $("#3").closest(".color-background-1.gradient>div").css("margin-top","100px");
  $("#3").closest(".color-background-1.gradient>div").css("border-top-left-radius","25px");
  $("#3").closest(".color-background-1.gradient>div").css("border-top-right-radius","25px");

  $("#3").closest(".color-background-1.gradient>div").css("border-top-left-radius","25px");
  $("#3").closest(".color-background-1.gradient>div").css("border-top-right-radius","25px");

  $(".collection__view-all").closest(".collection").css("border-bottom-left-radius","25px");
  $(".collection__view-all").closest(".collection").css("border-bottom-right-radius","25px");
  $(".collection__view-all a").text("LOAD MORE >");

   $(".collection__view-all").mouseover(function(){
     $(".collection__view-all a").css("background","#fff");
   });
   $(".card__heading.h5").hide();
   $(".card__heading.h5").each(function(index,el){
      let html = $(el).html();
      let title_html = `
       <div class="product_title" style="margin-bottom:10px!important;
       font-weight:400!important;
       font-size:1.3rem!important;
       ">${html}</div>
       `;
       $(el).closest("li").find(".price__container").after(title_html);
   })
  
}
